export const buildPPDLagoonTables = (ppdLagoon) => {
  // ## Loaders

  const loadingUhcUpdates = [];
  const loadingFeatureFlags = {};
  const loadingHomePageContents = {};
  const loadingUIMessages = {};
  const loadingHeaderContents = {};
  const loadingAdditionalToolsContentsObject = {};
  const loadingErrorMessages = {};
  const loadingAssets = {};

  // loading feature-flags
  ppdLagoon.lagoon
    .getTable('feature-flags')
    .getRow()
    .forEach((featureFlag) => {
      loadingFeatureFlags[featureFlag.key] = featureFlag.active;
    });

  // loading uhc-updates tables
  ppdLagoon.lagoon
    .getTable('uhc-updates')
    .getRow()
    .forEach((uhcUpdatesEntry) => {
      loadingUhcUpdates.push(uhcUpdatesEntry);
    });

  ppdLagoon.lagoon
    .getTable('home-page-contents')
    .getRow()
    .forEach((content) => {
      loadingHomePageContents[content.key] = content;
    });

  const loadingAdditionalToolsContentsArray = ppdLagoon.lagoon
    .getTable('additional-tools-contents')
    .getRow();

  ppdLagoon.lagoon
    .getTable('additional-tools-contents')
    .getRow()
    .forEach((content) => {
      loadingAdditionalToolsContentsObject[content.key] = content;
    });

  ppdLagoon.lagoon
    .getTable('ui-messages')
    .getRow()
    .forEach((uiMessage) => {
      loadingUIMessages[uiMessage.messageId] = uiMessage.message;
    });

  ppdLagoon.lagoon
    .getTable('error-messages')
    .getRow()
    .forEach((errorMsg) => {
      loadingErrorMessages[errorMsg.messageId] = errorMsg.message;
    });

  ppdLagoon.lagoon
    .getTable('header-contents')
    .getRow()
    .forEach((content) => {
      loadingHeaderContents[content.key] = content;
    });
  const loadingHeaderContentsInArray = ppdLagoon.lagoon
    .getTable('header-contents')
    .getRow();

  ppdLagoon.lagoon
    .getTable('assets')
    .getRow()
    .forEach((asset) => {
      loadingAssets[asset.key] = asset.imageUrl;
    });

  const ppdLagoonTables = {
    uhcUpdates: loadingUhcUpdates,
    featureFlags: loadingFeatureFlags,
    homePageContents: loadingHomePageContents,
    additionalToolsContentsArray: loadingAdditionalToolsContentsArray,
    additionalToolsContentsObject: loadingAdditionalToolsContentsObject,
    uiMessages: loadingUIMessages,
    headerContentsByKey: loadingHeaderContents,
    headerContentsInArray: loadingHeaderContentsInArray,
    errorMessages: loadingErrorMessages,
    assets: loadingAssets,
  };

  return ppdLagoonTables;
};
